import React from 'react'
import SbEditable from 'storyblok-react'
import Heading from 'src/components/Heading'
import GetSettings from 'src/utils/GetSettings'

const SimpleFourColumn = ({ blok }) => {
  const settings = GetSettings()

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className={`bg-white`}>
        <div className="max-w-7xl mx-auto px-6 lg:my-40 md:32 my-16">
          <Heading size="h2" className="text-darkblue lg:!mb-6">
            Our office location
          </Heading>
          <p className="prose text-darkblue-700">
            Cloud Gateway HQ is located in the heart of London. Pop by and chat
            to us!
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-2 xl:gap-20 text-darkblue-700 lg:mt-20 mt-12">
            <div>
              <Heading
                size="h7"
                className="text-brightgreen block font-semibold !mb-3"
              >
                Address
              </Heading>
              <span className="block tracking-[-0.03em] max-w-[190px]">
                {settings.address}
              </span>
            </div>
            <div>
              <Heading
                size="h7"
                className="text-brightgreen block font-semibold !mb-3"
              >
                Email
              </Heading>
              <a
                href={`mailto:${settings.email}`}
                className="block tracking-[-0.03em] hover:text-brightgreen duration-300"
              >
                {settings.email}
              </a>
            </div>
            <div>
              <Heading
                size="h7"
                className="text-brightgreen block font-semibold !mb-3"
              >
                Phone
              </Heading>
              <a
                href={`tel:${settings.telephone_number}`}
                className="block tracking-[-0.03em] hover:text-brightgreen duration-300"
              >
                {settings.telephone_number}
              </a>
            </div>
            <div>
              <Heading
                size="h7"
                className="text-brightgreen block font-semibold !mb-3"
              >
                Opening Hours
              </Heading>
              <div className="tracking-[-0.03em] max-w-[240px]">
                {settings.opening_hours}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  )
}

export default SimpleFourColumn
